import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { AutorizationService } from './autorization.service';
import { Observable, Subscriber } from 'rxjs';
import { Station } from '../models/api_models/station';
import { Token } from '../models/api_models/token';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { count } from 'rxjs/operators';
import { BasicResponse } from '../models/api_models/basicResponse';
import { IndexDetails } from 'ngx-indexed-db/lib/ngx-indexed-db';
import { CookieService } from 'ngx-cookie-service';



@Injectable({
  providedIn: 'root'
})

export class PublicService {
  publicUrl = "https://api1.clem.mobi/";

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    })
  };


  constructor(private cookieService: CookieService, private http: HttpClient, private autorizationService: AutorizationService, private dbService: NgxIndexedDBService) { }

  generateNewPublicToken() { }
  // private initDB() {
  //   let db = new NgxIndexedDB('Clem-db-tesst', 1);
  //   db.openDatabase(1, evt => {
  //     let objectStore = evt.currentTarget.result.createObjectStore('station', {
  //       keyPath: 'id',
  //       autoIncrement: false
  //     });


  //     objectStore.createIndex('autonomy', 'autonomy', {
  //       unique: false
  //     });
  //     objectStore.createIndex('available', 'available', {
  //       unique: false
  //     });
  //     objectStore.createIndex('car_name', 'car_name', {
  //       unique: false
  //     });
  //     objectStore.createIndex('guest_booking', 'guest_booking', {
  //       unique: false
  //     });
  //     objectStore.createIndex('id', 'id', {
  //       unique: false
  //     });
  //     objectStore.createIndex('latitude', 'latitude', {
  //       unique: false
  //     });
  //     objectStore.createIndex('longitude', 'longitude', {
  //       unique: false
  //     });
  //     objectStore.createIndex('name', 'name', {
  //       unique: false
  //     });
  //     objectStore.createIndex('type', 'type', {
  //       unique: false
  //     });
  //     objectStore.createIndex('expire_time', 'expire_time', {
  //       unique: false
  //     });

  //   });
  // }

  public forceClearStation() { }

  // private clearData() {

  // );



  //   let db = new NgxIndexedDB('Clem-db-tesst', 1);
  //   db.openDatabase(1).then(function () {
  //     let index_detail: IndexDetails = {
  //       indexName: 'expire_time',
  //       order: 'asc'
  //     }
  //     db.getAll('station', IDBKeyRange.lowerBound(Date.now(), true), index_detail).then(
  //       station => {
  //         if (( < Station[] > station).length > 0) {
  //           // conslog("clear indexeddb");
  //           db.delete("station", IDBKeyRange.upperBound(0));
  //         }
  //         // conslog(station);
  //       },
  //       error => {
  //         // conslog(error);
  //       }
  //     );
  //   });
  // }

  private updateExpireTime(service: PublicService) {
    let date = new Date();
    date.setTime(date.getTime() + (24 * 3600 * 1000));
    service.dbService.add('data_expire_time', {
      name: "stations_data",
      expire_time: date.toISOString()
    }).then(
      () => {
        return;
      },
      error => {
        // conslog(error);
      });
  }

  private saveDatabase(station: any, idx: number, service: PublicService) {
    if (station[idx] == undefined) {
      this.dbService.delete('data_expire_time', "stations_data").then(
        () => {
          return service.updateExpireTime(service);
        },
        error => {
          // conslog(error);
        }
      );
      return;
    }
    service.dbService.add('station', station[idx]).then(
      () => {
        service.saveDatabase(station, ++idx, service);
      },
      error => {
        // conslog(error);
      }
    );
  }


  private storeNewStation(stations, type) {


    let data = {
      "expire_time": (Date.now() + (24 * 3600 * 1000)),
      "stations": stations.data
    };
    window.sessionStorage.setItem("stations_data" + type, JSON.stringify(data));
  }

  private storeStation(stations) {
    let service = this;
    service.saveDatabase(stations, 0, service);
  }




  public apigetStation(observer: Subscriber<Station[]>, type) {
    this.autorizationService.login(null).subscribe(reponse => {
      let token = <Token>reponse;

      if (token == null) {
        observer.next(null)
        observer.complete()
      }
      // const header = {
      //   headers: new HttpHeaders()
      //     .set('Authorization', 'Bearer ' + token.access_token)
      // }





      if (localStorage.getItem('token_clem_mobi')) {

        let tokenString = localStorage.getItem('token_clem_mobi')
        let token = JSON.parse(tokenString)

        const header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        }


        console.log("type==============")
        console.log(type)
        console.log("type---------")


        
        if (type === 0) {
          type = '0&type[]=7'
        }
        if (type === 1) {
          type = '1'
        }
        if (type === 10) {
          type = '10'
        }



        this.http.get(this.publicUrl + "api/v2/stations?type[]=" + type + "&_response=compact", header).subscribe(
          reponse => {
            let data = (<BasicResponse>reponse).data;
            // conswarn(data);
            this.storeStation(<Station[]>data);
            // conslog("storeData");
            observer.next(<Station[]>(<BasicResponse>reponse).data);
            observer.complete();

          }, error => {
            this.storeStation([]);
            observer.next([]);
            observer.complete();
          });

      } else {
        const header = {
          headers: new HttpHeaders()
            .set('Authorization', 'Bearer ' + token.access_token)
        }
        if (type === 0) {
          type = '0&type[]=7'
        }
        if (type === 1) {
          type = '1'
        }
        if (type === 10) {
          // type = '10&type[]=12'
          type = '10'
        }
        if (type === 12) {
          // type = '10&type[]=12'
          type = '12'
        }


        this.http.get(this.publicUrl + "api/v2/guest/stations?type[]=" + type + "&_response=compact", header).subscribe(
          reponse => {
            let data = (<BasicResponse>reponse).data;
            // conswarn(data);
            this.storeStation(<Station[]>data);
            // conslog("storeData");
            observer.next(<Station[]>(<BasicResponse>reponse).data);
            observer.complete();

          }, error => {
            this.storeStation([]);
            observer.next([]);
            observer.complete();
          });

      }







    });
  }


  private loadStation(observer: Subscriber<Station[]>, type) {
    let service: PublicService = this;
    this.dbService.getByIndex('station', 'type', type).then(
      station => {
        // conswarn("nb station type " + type);

        if (station != undefined && (<Station[]>station).length > 0) {
          // conswarn(station);

          observer.next(<Station[]>station);
          observer.complete();
        } else {
          service.apigetStation(observer, type);
        }
      },
      error => { }
    );
  }

  getStationList(type) {
    //  alert(type);
    return new Observable<Station[]>((observer) => {
      this.apigetStation(observer, type);
    });
    // return new Observable < Station[] > ((observer) => {
    //   this.dbService.getByIndex('data_expire_time', 'name', 'station-data').then(
    //     data => {
    //       if (data !== null) {
    //         let data_expire_time = new Date(data.data_expire_time);
    //         let currentDate = new Date();
    //         if (data_expire_time < currentDate) {
    //           this.dbService.clear('station').then(
    //             () => {
    //               this.loadStation(observer, type);
    //             },
    //             error => {
    //               // conslog(error);
    //             }
    //           );
    //         }
    //       } else {

    //       }
    //     },
    //     error => {
    //       // conslog(error);
    //     }
    //   );

    //});




    // this.initDB();
    // let cacheData: Station[] = this.loadStation(type);
    // // conslog(cacheData);

    // if (cacheData != null) {
    //   return new Observable < Station[] > ((observer) => {
    //     observer.next(cacheData)
    //     observer.complete()
    //   })
    // }
    // return new Observable < Station[] > ((observer) => {
    //   this.autorizationService.login(null).subscribe(reponse => {
    //     let token = < Token > reponse;

    //     if (token == null) {
    //       observer.next(null)
    //       observer.complete()
    //     }
    //     var header = {
    //       headers: new HttpHeaders()
    //         .set('Authorization', 'Bearer ' + token.access_token)
    //     }
    //     cacheData = null;
    //     //            this.GetALLStations(0,token, observer);
    //     this.http.get(this.publicUrl + "api/v2/guest/stations?type[]=" + type, header).subscribe(
    //       reponse => {
    //         this.storeStation(reponse, type);
    //         observer.next(this.loadStation(type))
    //         observer.complete()

    //       }, error => {
    //         observer.next(cacheData)
    //         observer.complete()
    //       });

    //   });


    // })
  }

}
